"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guard = guard;
var _debrief = require("debrief");

/**
 * Alternative for serialize() that does not echo back the input value.
 */
function serializeSimple(annotation) {
  return (0, _debrief.summarize)(annotation).join('\n');
}
function guard(decoder, options) {
  var o = options || {};
  var style = o.style || 'inline';
  var serializer = style === 'inline' ? _debrief.serialize // Normal serializer, which echoes back inputted value and inlines errors
  : serializeSimple; // Only returns error messages, without echoing back input

  return function (blob) {
    return decoder(blob).mapError(function (annotation) {
      var err = new Error('\n' + serializer(annotation));
      err.name = 'Decoding error';
      return err;
    }).unwrap();
  };
}